import React, {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './styles/subscribe.module.css'
import mockup from "../../../assets/images/mockup2.png"; // Import the mockup image
import bgimage1 from "../../../assets/images/Ellipse5.png"
import bgimage2 from "../../../assets/images/Ellipse2.png"
import bgimage3 from "../../../assets/images/Ellipse3.png"

const Subscribe: React.FC = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // Duration of the animation
      easing: 'ease-in-out', // Easing function
      once: true, // Animation should run once
    });
  }, []);

  return (
    
    <section id="pricing" className="w-10/12 mx-auto py-20 mt-18 sm:mt-36 flex flex-col-reverse md:flex-row items-center justify-between relative">

    <div
    className={`hidden sm:block absolute top-0 right-0 z-0 ${styles.hideEllipses}`}
    style={{
        backgroundImage: `url(${bgimage1})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '200px',
        height: '200px', 
        transform: 'translate(60%, -5%)', 
    }}
    ></div>

    <div
        className={`hidden sm:block absolute bottom-0 right-0 z-0 ${styles.hideEllipses}`}
        style={{
        backgroundImage: `url(${bgimage2})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '150px', 
        height: '150px',
        transform: 'translate(80%, 124.3%)', 
        }}
    ></div>

    <div
        className={`hidden sm:block absolute bottom-0 left-0 z-0 ${styles.hideEllipses}`}
        style={{
        backgroundImage: `url(${bgimage3})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '150px',
        height: '150px',
        transform: 'translate(-80%, 85.2%)', // Push it slightly outward to the left
        }}
    ></div>

      {/* Left Content */}
      <div data-aos="fade-up" data-aos-delay="400" className="text-center md:text-left md:w-1/2">
        <h2 className={` ${styles.subscribe_text} text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-black leading-tight`}>
          Do even more with <br className={styles.hideBreak} /> Beat Fussion premium
        </h2>
        <p className="text-md sm:text-base text-gray-600 mt-4">
          Subscribe for just $5 and get exclusive access to match streams and
          voting rights. Your voice, their spotlight—join the movement today.
        </p>
        <button className="mt-8 px-6 py-3 text-white bg-purple-600 rounded-lg shadow-md hover:bg-purple-700 transition duration-300">
          Get Started
        </button>
      </div>

      {/* Right Image */}
      <div data-aos="fade-up" data-aos-delay="500" className="md:w-1/3 mb-16 sm:mb-0 flex justify-center relative">
        <img
          src={mockup}
          alt="Beat Fussion Premium"
          className="w-80 sm:w-96 md:w-full object-contain"
        />
      </div>

      {/* Bottom Ellipse Decoration */}
      <div
        className="hidden sm:block absolute -bottom-10 right-0 z-0"
        style={{
          backgroundImage: `url('/path/to/ellipseImage.png')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          width: "200px",
          height: "200px",
        }}
      ></div>
    </section>
  );
};

export default Subscribe;
